// source: pbtypes/gen/surface_scan/viewpoints_state.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_scan_planner_scan_photo_pb = require('../../../pbtypes/gen/scan_planner/scan_photo_pb.js');
goog.object.extend(proto, pbtypes_gen_scan_planner_scan_photo_pb);
var pbtypes_gen_surface_scan_viewpoints_error_pb = require('../../../pbtypes/gen/surface_scan/viewpoints_error_pb.js');
goog.object.extend(proto, pbtypes_gen_surface_scan_viewpoints_error_pb);
var pbtypes_gen_surface_scan_viewpoints_status_pb = require('../../../pbtypes/gen/surface_scan/viewpoints_status_pb.js');
goog.object.extend(proto, pbtypes_gen_surface_scan_viewpoints_status_pb);
goog.exportSymbol('proto.surface_scan.ViewpointsState', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.surface_scan.ViewpointsState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.surface_scan.ViewpointsState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.surface_scan.ViewpointsState.displayName = 'proto.surface_scan.ViewpointsState';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.surface_scan.ViewpointsState.prototype.toObject = function(opt_includeInstance) {
  return proto.surface_scan.ViewpointsState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.surface_scan.ViewpointsState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.surface_scan.ViewpointsState.toObject = function(includeInstance, msg) {
  var f, obj = {
status: jspb.Message.getFieldWithDefault(msg, 1, 0),
created: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
name: jspb.Message.getFieldWithDefault(msg, 4, ""),
ispImgPath: jspb.Message.getFieldWithDefault(msg, 5, ""),
tegraImgPath: jspb.Message.getFieldWithDefault(msg, 6, ""),
mediaId: jspb.Message.getFieldWithDefault(msg, 8, ""),
photo: (f = msg.getPhoto()) && pbtypes_gen_scan_planner_scan_photo_pb.ScanPhoto.toObject(includeInstance, f),
error: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.surface_scan.ViewpointsState}
 */
proto.surface_scan.ViewpointsState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.surface_scan.ViewpointsState;
  return proto.surface_scan.ViewpointsState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.surface_scan.ViewpointsState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.surface_scan.ViewpointsState}
 */
proto.surface_scan.ViewpointsState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.surface_scan.ViewpointsStatus.Enum} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCreated(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setIspImgPath(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setTegraImgPath(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setMediaId(value);
      break;
    case 9:
      var value = new pbtypes_gen_scan_planner_scan_photo_pb.ScanPhoto;
      reader.readMessage(value,pbtypes_gen_scan_planner_scan_photo_pb.ScanPhoto.deserializeBinaryFromReader);
      msg.setPhoto(value);
      break;
    case 10:
      var value = /** @type {!proto.surface_scan.ViewpointsError.Enum} */ (reader.readEnum());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.surface_scan.ViewpointsState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.surface_scan.ViewpointsState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.surface_scan.ViewpointsState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.surface_scan.ViewpointsState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getCreated();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIspImgPath();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTegraImgPath();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMediaId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPhoto();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      pbtypes_gen_scan_planner_scan_photo_pb.ScanPhoto.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
};


/**
 * optional ViewpointsStatus.Enum status = 1;
 * @return {!proto.surface_scan.ViewpointsStatus.Enum}
 */
proto.surface_scan.ViewpointsState.prototype.getStatus = function() {
  return /** @type {!proto.surface_scan.ViewpointsStatus.Enum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.surface_scan.ViewpointsStatus.Enum} value
 * @return {!proto.surface_scan.ViewpointsState} returns this
 */
proto.surface_scan.ViewpointsState.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional bool created = 3;
 * @return {boolean}
 */
proto.surface_scan.ViewpointsState.prototype.getCreated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.surface_scan.ViewpointsState} returns this
 */
proto.surface_scan.ViewpointsState.prototype.setCreated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.surface_scan.ViewpointsState.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.surface_scan.ViewpointsState} returns this
 */
proto.surface_scan.ViewpointsState.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string isp_img_path = 5;
 * @return {string}
 */
proto.surface_scan.ViewpointsState.prototype.getIspImgPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.surface_scan.ViewpointsState} returns this
 */
proto.surface_scan.ViewpointsState.prototype.setIspImgPath = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string tegra_img_path = 6;
 * @return {string}
 */
proto.surface_scan.ViewpointsState.prototype.getTegraImgPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.surface_scan.ViewpointsState} returns this
 */
proto.surface_scan.ViewpointsState.prototype.setTegraImgPath = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string media_id = 8;
 * @return {string}
 */
proto.surface_scan.ViewpointsState.prototype.getMediaId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.surface_scan.ViewpointsState} returns this
 */
proto.surface_scan.ViewpointsState.prototype.setMediaId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional scan_planner.ScanPhoto photo = 9;
 * @return {?proto.scan_planner.ScanPhoto}
 */
proto.surface_scan.ViewpointsState.prototype.getPhoto = function() {
  return /** @type{?proto.scan_planner.ScanPhoto} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_scan_planner_scan_photo_pb.ScanPhoto, 9));
};


/**
 * @param {?proto.scan_planner.ScanPhoto|undefined} value
 * @return {!proto.surface_scan.ViewpointsState} returns this
*/
proto.surface_scan.ViewpointsState.prototype.setPhoto = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.surface_scan.ViewpointsState} returns this
 */
proto.surface_scan.ViewpointsState.prototype.clearPhoto = function() {
  return this.setPhoto(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.surface_scan.ViewpointsState.prototype.hasPhoto = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional ViewpointsError.Enum error = 10;
 * @return {!proto.surface_scan.ViewpointsError.Enum}
 */
proto.surface_scan.ViewpointsState.prototype.getError = function() {
  return /** @type {!proto.surface_scan.ViewpointsError.Enum} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.surface_scan.ViewpointsError.Enum} value
 * @return {!proto.surface_scan.ViewpointsState} returns this
 */
proto.surface_scan.ViewpointsState.prototype.setError = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


goog.object.extend(exports, proto.surface_scan);
